import {
  faDatabase,
  faImage,
  faRunning,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  DetailList,
  Heading,
  SideNav,
  SideNavItem,
} from '@orobix/orobix-fe-components'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation } from 'react-router-dom'

import DemoBadge from '../../components/DemoBadge/DemoBadge'
import EditLabelModal from '../../components/EditLabelModal/EditLabelModal'
import { USER_LEVEL } from '../../components/Settings/definitions'
import { SettingsContext } from '../../components/Settings/SettingsContext'
import { useStore } from '../../store/store'
import { getAnnotationTypeBy } from '../../types/annotation'
import { formatDate } from '../../utils/date'
import { locations } from '../../utils/locations'
import { getProductClassesList, getProductTypeName } from '../../utils/products'
import { isProductDemo } from '../../utils/productTypes'
import { useObservationsCount } from '../Trainings/useObservationsCount'
import useStyles from './DatasetsAside.styles'

const DatasetsAside = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { product, project } = useStore()
  const imagesCounter = useObservationsCount(product?.id ?? 0)
  const { settings } = useContext(SettingsContext)
  const history = useHistory()
  const location = useLocation()
  const isExpertUser = settings.preference__user_level === USER_LEVEL.expert

  const getProductDescription = () =>
    product && product.description
      ? [
          {
            title: t('Info'),
            value: product.description,
          },
        ]
      : []

  return product && project ? (
    <div id="asideDivId">
      <Heading headingLevel="1" noTopMargin>
        {product.name}
      </Heading>

      <SideNav>
        <div id="trainingsButtonId">
          <SideNavItem
            label={t('Trainings')}
            active={location.pathname.includes('/trainings')}
            onClick={() =>
              history.push(locations.trainings(project.id, product.id))
            }
            icon={<FontAwesomeIcon icon={faRunning} />}
          />
        </div>
        <div id="imagesButtonId">
          <SideNavItem
            label={t('Images')}
            active={location.pathname.endsWith('images')}
            onClick={() =>
              history.push(locations.images(project.id, product.id))
            }
            icon={<FontAwesomeIcon icon={faImage} />}
          />
        </div>
        {isExpertUser && (
          <div id="datasetsButtonId">
            <SideNavItem
              label={t('Datasets')}
              active={location.pathname.includes('/datasets')}
              onClick={() =>
                history.push(locations.datasets(project.id, product.id))
              }
              icon={<FontAwesomeIcon icon={faDatabase} />}
            />
          </div>
        )}
      </SideNav>
      <DetailList
        list={[
          ...getProductDescription(),
          {
            title: t('Created on'),
            value: formatDate(product.creationDate),
          },
          {
            title: t('Type'),
            value: (
              <div className={classes.productType}>
                <div className={classes.productTypeName}>
                  {getProductTypeName(product.type)}
                </div>
                {isProductDemo(product.type) && <DemoBadge />}
              </div>
            ),
          },
          {
            title: t('Classes'),
            value: getProductClassesList(product.type, product.productClasses),
          },
          ...(getAnnotationTypeBy(product.type) !== 'Tag'
            ? [
                {
                  title: t('Labels'),
                  value: <EditLabelModal productId={product.id} />,
                },
              ]
            : []),
          {
            title: t('Images'),
            value: imagesCounter,
          },
        ]}
      />
    </div>
  ) : null
}

export default DatasetsAside
